import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	scimManagedOrganizationTooltipNonFinal: {
		id: 'servicedesk-customers-organization-common.common.organizations-select-field.organizations-single-select.lock-option.scim-managed-organization-tooltip-nonfinal',
		defaultMessage: "Customers can't be added to an organization synced from an external directory",
		description:
			'Tooltip message for the lock icon next to a SCIM managed organization on the single select option',
	},
	scimManagedOrganizationLockIconLabelNonFinal: {
		id: 'servicedesk-customers-organization-common.common.organizations-select-field.organizations-single-select.lock-option.scim-managed-organization-lock-icon-label-nonfinal',
		defaultMessage: 'SCIM managed organization',
		description:
			'Label for the lock icon next to a SCIM managed organization on the single select option',
	},
});
